import React, { useContext, useEffect, useState } from 'react';
import styled from 'styled-components';
import moment from 'moment';
import colors from '../../../styles/colors';
import BaseModal, { ModalList } from '../../modals/BaseModal';
import Loader from '../../Loader';
import Icon, { Icons } from '../../Icon';
import { AppContext } from '../../../context/AppContext';
import { NoContent } from '../CustomerTable';
import NoContent1 from '../../../shared/NoContent';

const ListWrapper = styled.div`
  position: relative;
  width: 100%;
  min-height: 60vh;
  @media screen and (max-width: 450px) {
    max-height: 75vh;
    height:75vh;
  }
`;

const ListContainer = styled.ul`
  width: 100%;
  position: relative;
  height: auto;
  max-height: 75vh;
  overflow: auto;
  display: grid;
  box-shadow: 0px 4px 16px rgba(0, 0, 0, 0.05);
  margin: 0;
  /* grid-template-columns: 1fr; */
 
`;

const ListHeader = styled.div`
  display: flex;
  position: sticky;
  top: 0;
  flex-direction: column;
  height: auto;
  border: 1px solid ${colors.grey6};
  background: ${colors.white};
  z-index: 15;
`;

const ListHeaderInner = styled.div`
  font-weight: 450;
  font-size: 1.2rem !important;
  padding: 7px 35px;
  color: #333333;
  list-style-type: none;
  display: flex;
  justify-content: space-around;
  align-items: center;
  height: auto;
  min-height: 50px;
  text-align: start;
  border: 1px solid ${colors.grey6};
  background: ${colors.white};
`;

const ListHeaderItem = styled.div`
  cursor: pointer;
  display: flex;
  justify-content: center;
  align-items: center;
  font-weight: 600;
`;

const ListItem = styled.li`
  cursor: pointer;
  font-size: 1.2rem !important;
  padding: 7px 35px;
  color: #333333;
  list-style-type: none;
  display: flex;
  justify-content: space-around;
  align-items: center;
  height: auto;
  min-height: 50px;
  font-size: 17px;
  position: relative;
  text-align: start;
  border: 1px solid ${colors.grey6};
`;

const LoaderContainer = styled.div`
  display: flex;
  align-items: center;
  height: 95%;
  justify-content: center;
  position: absolute;
  top: 0;
  left: 50%;
  transform: translateX(-50%);
  z-index: 2000;
`;

const LoaderContainer1 = styled.div`
  width: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
  min-height: 50vh;
`;

const TableHeaderCompnent = ({ ordering, ...props }) => {
  const { fieldName, order } = ordering;
  let orderingIcon = (
    <Icon
      icon={Icons.Sort}
      size={12}
      margin="5px"
      active
      activeColor={colors.grey3}
    />
  );

  if (fieldName === props.columnName && order === 'asc') {
    orderingIcon = (
      <Icon
        margin="5px"
        icon={Icons.SortUp}
        size={12}
        active
        activeColor={colors.grey3}
      />
    );
  } else if (fieldName === props.columnName && order === 'desc') {
    orderingIcon = (
      <Icon
        margin="5px"
        icon={Icons.SortDown}
        size={12}
        active
        activeColor={colors.grey3}
      />
    );
  }

  return (
    <ListHeaderItem onClick={() => props.handleSort(props.columnName)}>
      {props.children} {orderingIcon}
    </ListHeaderItem>
  );
};

export default function ContactsList({
  contacts,
  fetchMore,
  ordering,
  handleSort,
  isMore,
  loadMoreData,
  fetching,
  setFetching,
  getRefferedContactsClick,
  loading,
  filterApplied,
  scrollToTop,
}) {
  const [detailsModalVisible, setDetailsModalVisible] = useState(false);
  const { app } = useContext(AppContext);
  const [contactData, setContactData] = useState({});
  const scrollContainer = React.useRef();

  const handleScroll = () => {
    if (!fetchMore) return;
    if (scrollContainer?.current.scrollTop > 0) {
      const scrollPosition = scrollContainer?.current.offsetHeight
        + scrollContainer?.current.scrollTop;
      const scrollPositionMax = scrollContainer?.current.scrollHeight - 300;
      if (scrollPosition >= scrollPositionMax && !fetching && isMore) {
        setFetching(true);

        setTimeout(() => {
          loadMoreData();
          setFetching(false);
        }, 0);
      }
    }
  };

  const listItemClick = (contactData) => {
    setContactData(contactData);

    setDetailsModalVisible(true);
  };

  useEffect(() => {
    if (scrollContainer?.current) {
      scrollContainer.current.scrollTop = 0;
    }
  }, [scrollToTop]);

  return (
    <ListWrapper>
      <BaseModal
        open={detailsModalVisible}
        modalType={ModalList.SuperAdminContactDetailsModal}
        onClose={setDetailsModalVisible}
        contactData={contactData}
        getRefferedContactsClick={getRefferedContactsClick}
        fetching={fetching}
        setFetching={setFetching}
      />

      {loading ? (
        <LoaderContainer1>
          <Loader />
        </LoaderContainer1>
      ) : (
        <>
          {fetching && (
            <LoaderContainer>
              <Loader />
            </LoaderContainer>
          )}

          {(contacts && contacts.length > 0 && filterApplied) || fetching ? (
            <ListContainer ref={scrollContainer} onScroll={handleScroll}>
              <ListHeader>
                {(app?.searchQuery?.phoneNumber || app?.refSearchNumber)
                  && contacts.length > 0 && (
                    <NoContent
                      contacts={contacts}
                      height="fit-content"
                      direction="row"
                      textWidth="50%"
                    />
                )}
                <ListHeaderInner>
                  <TableHeaderCompnent
                    ordering={ordering}
                    handleSort={handleSort}
                    columnName="phoneNumber"
                  >
                    Phone Number
                  </TableHeaderCompnent>
                  <TableHeaderCompnent
                    ordering={ordering}
                    handleSort={handleSort}
                    columnName="createdAt"
                  >
                    Created At
                  </TableHeaderCompnent>
                </ListHeaderInner>
              </ListHeader>
              {contacts.map((contact) => {
                return (
                  <ListItem
                    key={contact._id}
                    onClick={() => listItemClick(contact)}
                  >
                    <div>{contact.phoneNumber}</div>
                    <div>{moment(contact.createdAt * 1000).format('L')}</div>
                  </ListItem>
                );
              })}
            </ListContainer>
          ) : (
            <>
              <NoContent1
                header={
                  filterApplied ? 'No Contacts Found' : 'No filter Applied'
                }
                description={
                  filterApplied
                    ? 'Please try with some other filters'
                    : 'Please apply some filters to get contacts'
                }
              />
            </>
          )}
        </>
      )}
    </ListWrapper>
  );
}
